var menuIsOpen = false;
jQuery(function($) {
    hasScroll();
    //Adding a class to indicate that the page is scrolled
    $(window).scroll(function () {
        hasScroll();
    });

    if($('.nav-tabs').length > 0){
        positionTabs();
        $(window).on('resize', function(){
            positionTabs();
        });
    }

    if($('.chronicles-bar').length > 0){
        $('.chronicles-bar .select-items div').on('click', function(){
            $('#filter').submit();
        });
    }

    if($('.calendar-bar').length > 0){
        $('.calendar-bar .select-items div').on('click', function(){
            $('#filter').submit();
        });
    }

    //Not outputing empty query params on form submit
    $('#filter').submit(function () {
        $(this)
            .find('select option[value=""]:selected').closest("select").attr('name', '')
            .filter(function () {
                return !this.value;
            })
            .prop('name', '');
    });

    //inits on screen masonry only
    if($('.masonry').length > 0){
        $('.masonry').masonry({
            itemSelector: '.grid-item',
        });
    }

    $('#tabbed-gallery .nav-item .nav-link').on('click', function(){
        $('.masonry').masonry({
            itemSelector: '.grid-item',
        });
    });

    if($('.f-date input').length > 0){
        //Initialize date inputs
        $('.f-date input').datepicker({
            dateFormat: "d/m/Y",
            orientation: "bottom",
            minViewMode: "days",
            maxViewMode: "days",
            startDate: new Date($('.f-date input').data('startdate')),
            endDate: new Date($('.f-date input').data('enddate'))
        });

        var date = new Date();

        if(date < new Date($('.f-date input').data('startdate')) || date > new Date($('.f-date input').data('enddate'))){
            date = new Date($('.f-date input').data('startdate'));
        }
        
        $('.f-date input').datepicker('update', date);
    }


    if($('.wellbeing-slider').length > 0){
        $('.wellbeing-slider').slick({
            dots: true,
            infinite: false,
            autoplay: false,
            slidesToShow: 3.5,
            arrows: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                      slidesToShow: 2.5,
                      slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1.5,
                      slidesToScroll: 1,
                    }
                },
            ]
        });
    }

    if($('.latest-events-slider').length > 0){
        $('.latest-events-slider').slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            responsive: [
                {
                  breakpoint: 1500,
                  settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                  }
                },
                {
                    breakpoint: 900,
                    settings: {
                      slidesToShow: 1.5,
                      slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1.2,
                      slidesToScroll: 1,
                    }
                },
            ]
		});
    }
    if($('.gallery-slider').length > 0){
        $('.gallery-slider').slick({
            dots: true,
            infinite: false,
            autoplay: false,
            slidesToShow: 5,
            arrows: false,
            responsive:
            [
                {
                    breakpoint: 1600,
                    settings: {
                    slidesToShow: 3.8,
                    slidesToScroll: 3,
                    dots: true,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 3.6,
                    slidesToScroll: 3,
                    dots: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                    slidesToShow: 2.8,
                    slidesToScroll: 2,
                    dots: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 2,
                    dots: true,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    // centerMode: true,
                    dots: true,
                    }
                }
            ]
        });

        $('.view-all').on('click', function(e){
			e.preventDefault();
			$('.slide').eq(0).find('img').click();
		});
    }

	if($('.gallery-image').length > 0){
		$('.view-all').on('click', function(e){
			e.preventDefault();
			$('.gallery-image').eq(0).find('img').click();
		});
	}

    if($('.showcase').length > 0){
        var showCaseImage = $('.showcase').find('.showcase-image img');
        $('.showcase-title').on('mouseenter', function(){
            var showCaseImageSrc = $(this).data('image');
            showCaseImage.attr('src', showCaseImageSrc);
            showCaseImage.attr('srcset', showCaseImageSrc);
            $('.showcase-title').removeClass('active');
            $(this).addClass('active');
        });
    }

    if($('.rooms-slider .slider').length > 0 ){

        var roomSlides = $('.rooms-slider').find('.slide');
        var roomsImage = $('.rooms-slider .slider-wrap .bg-img img');
        //Init text slider
        $('.rooms-slider .slider').slick({
            dots: false,
            arrows: false,
            centerMode: true,
            variableWidth: true,
            slidesToShow: 1,
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var roomsImageSrc = roomSlides.eq(nextSlide).data('image');
            roomsImage.attr('src', roomsImageSrc);
            roomsImage.attr('srcset', roomsImageSrc);
        });
    }

    if($('.calendar-slider .slider').length > 0 ){

        var calendarSlides = $('.calendar-slider').find('.slide');
        var calendarImage = $('.calendar-slider .slider-wrap .bg-img img');
        //Init text slider
        $('.calendar-slider .slider').slick({
            dots: false,
            arrows: false,
            centerMode: true,
            variableWidth: true,
            slidesToShow: 1,
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var calendarImageSrc = calendarSlides.eq(nextSlide).data('image');
            calendarImage.attr('src', calendarImageSrc);
            calendarImage.attr('srcset', calendarImageSrc);
        });
    }

    $('.file-upload #cv').change(function() {
        var file = $(this)[0].files[0].name;
        $('.file-upload #uploadMe').text(file);
    });

    if($('.video-container video').length > 0 ){
        videoAnim();
    }

    if($('#retreats-map').length > 0 ){
        mapAnim();
    }

    if ( $('.slidein-img-cont').length > 0 ){
        slideInImages()
      }

    $('#open-menu').on('click', function(){
        menuOpen();
    });

    $('#menu-close').on('click', function(){
        menuClose();
    });

    // $(".chosen-select").chosen({
    //   no_results_text: "Oops, nothing found!"
    // });

    // $('.select-items div').on('click', function(){
    //     index = $(this).index();

    //     $(this).parent().parent().find( "select option" ).eq(index + 1).attr('selected', true);
    // //   console.log(index);
    // //   console.log($(this).parent().parent());
    // //   console.log($(this).parent().parent().find( "select option" ).eq(index));
    // });



});

var previousScrollY = 0;

function menuOpen(){
    if(!jQuery('#mainMenuWrapper ').hasClass('show')){
        jQuery('#mainMenuWrapper .menu-left').addClass('menu-transition-left');
        jQuery('#mainMenuWrapper .menu-right').addClass('menu-transition-right');
        jQuery('#mainMenuWrapper').addClass('show');
        previousScrollY = window.scrollY;
        jQuery('body').addClass('freeze').css({
            marginTop: -previousScrollY,
        });
        if(previousScrollY > 5){
            menuIsOpen = true;
        }
    }
}

function menuClose(){
    if(jQuery('#mainMenuWrapper').hasClass('show')){
        jQuery('#mainMenuWrapper').removeClass('show');
        jQuery('body').removeClass('freeze').css({
            marginTop: 0,
        });
        window.scrollTo({
            top: previousScrollY,
            left: 0,
            behavior: 'instant'
        });
        menuIsOpen = false;
    }
}


var x, i, j, l, ll, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("f-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);

function slideInImages(){
    var time = 0;
    gsap.utils.toArray(".slidein-img-cont").forEach(item => {
        gsap.from(item.querySelector('img'), {
            scrollTrigger: {
                trigger: item,
                start: () => "top 80%",
                // toggleActions: "restart complete restart reverse",
            },
            x: "-100%",
            duration: .6,
            delay: time
        });
        time = time + 0.10;
    });
}

function mapAnim(){

    gsap.from($('#map'), {
        scrollTrigger: {
            trigger: $('.map-section'),
            start: () => "top bottom",
            //toggleActions: "restart complete restart reverse",
        },
        scale: 0.6,
    });
}

function videoAnim(){
    gsap.from($('.video-container video'), {
        scrollTrigger: {
            trigger: $('.video-container'),
            start: () => "top bottom",
            //toggleActions: "restart complete restart reverse",
        },
        scale: 0.6,
    });
}

function hasScroll(){
    if (jQuery(window).scrollTop() > 5){
        jQuery('body').addClass("scrolled");
    }
    else{
        if(!menuIsOpen){
            jQuery('body').removeClass("scrolled");
        }
    }
}

function positionTabs(){
    var tabsWidth = 0;
    jQuery('.nav-tabs li').each(function(){
        tabsWidth = tabsWidth + jQuery(this).width();
    });
    console.log(jQuery(window).width() - tabsWidth);
    if (jQuery(window).width() - tabsWidth < 30) {
        $('.nav-tabs').removeClass('justify-content-center');
    }else{
        jQuery('.nav-tabs').addClass('justify-content-center');
    }

}
